import * as React from 'react';
import { useAdyen } from '@grandvisionhq/payments';
import { getPaymentImplementation, getPaymentMethodSettings } from '../Payments/providers.js';

const useRenderPaymentForm = ()=>{
    const { config  } = useAdyen();
    const [selectedPaymentDetails, setSelectedPaymentDetails] = React.useState();
    const [selectedPaymentMethod, setSelectedPaymentMethod] = React.useState();
    const handlePaymentDataChange = React.useCallback((paymentData, isValid)=>{
        if (!selectedPaymentMethod) {
            return;
        }
        setSelectedPaymentDetails({
            data: paymentData,
            type: selectedPaymentMethod.type,
            isValid
        });
    }, [
        selectedPaymentMethod
    ]);
    const onPaymentMethodChanged = React.useCallback((paymentMethod)=>{
        setSelectedPaymentMethod(paymentMethod);
    }, []);
    const renderPaymentForm = React.useMemo(()=>{
        if (!selectedPaymentMethod) {
            return null;
        }
        const implementation = getPaymentImplementation(selectedPaymentMethod.provider, selectedPaymentMethod.type);
        // Get settings that are passed to payment settings provider from the OpCo site
        const settings = getPaymentMethodSettings(selectedPaymentMethod.provider, selectedPaymentMethod.type, config);
        if (!implementation || !implementation.form) {
            return null;
        }
        return /*#__PURE__*/ React.createElement(implementation.form, {
            onChange: handlePaymentDataChange,
            details: selectedPaymentDetails && selectedPaymentDetails.data,
            config: selectedPaymentMethod.config,
            settings
        });
    }, [
        config,
        selectedPaymentDetails,
        selectedPaymentMethod,
        handlePaymentDataChange
    ]);
    return React.useMemo(()=>[
            renderPaymentForm,
            selectedPaymentDetails,
            onPaymentMethodChanged
        ]
    , [
        renderPaymentForm,
        selectedPaymentDetails,
        onPaymentMethodChanged
    ]);
};

export { useRenderPaymentForm };
//# sourceMappingURL=use-render-payment-form.js.map
